/**
 * Franchise Inquiry Page Routes
 * FSD: pages/franchise-inquiry
 */

import { RouteObject } from "react-router-dom";
import { FranchiseInquiryPage } from "./ui/FranchiseInquiryPage";

export const franchiseInquiryRoute: RouteObject = {
  path: "/franchise-inquiry",
  element: <FranchiseInquiryPage />,
};

export default franchiseInquiryRoute;
